import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mine-index" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container_left" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "bar_wa" }
const _hoisted_6 = { class: "code_wa" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "container_right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_diV = _resolveComponent("diV")!
  const _component_sideBar = _resolveComponent("sideBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_diV, { class: "avatar_wa" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_avatar, {
              size: 88,
              src: _ctx.user.avatar
            }, null, 8, ["src"]),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user.nickname), 1)
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line_div" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_sideBar)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line_div" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "code_img",
            src: require('@/assets/images/common/codeApp.png')
          }, null, 8, _hoisted_7),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "code_p" }, "知鸦通识app，观看收听更方便", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}